import { ref } from 'vue';
import otpChannel from 'dashboard/api/channel/otpChannel';

export function useOtpService() {
  const service = ref(null);
  const loading = ref(false);
  const deliveries = ref([]);
  const sessions = ref([]);

  async function loadDeliveries() {
    const response = await otpChannel.getDeliveries();
    deliveries.value = response.data;
  }

  async function loadSessions() {
    const response = await otpChannel.getSessions();
    sessions.value = response.data;
  }

  async function load() {
    loading.value = true;
    try {
      const response = await otpChannel.getService();
      service.value = Object.keys(response.data).length ? response.data : null;
      if (service.value) {
        await loadSessions();
        await loadDeliveries();
      } else {
        sessions.value = [];
        deliveries.value = [];
      }
    } finally {
      loading.value = false;
    }
  }

  async function create(name) {
    const response = await otpChannel.createService(name);
    service.value = response.data;
    await loadSessions();
  }

  async function remove() {
    await otpChannel.deleteService();
    service.value = null;
    deliveries.value = [];
    sessions.value = [];
  }

  async function connectChannel(sessionKey) {
    await otpChannel.connectWhatsappSession(sessionKey);
    await load();
  }

  return {
    service,
    loading,
    deliveries,
    sessions,
    load,
    create,
    remove,
    connectChannel,
    loadSessions,
  };
}
